// Client-side browser notifications for today's reminder-enabled activities.
// Uses the Notification API. No server, no dependencies.

const DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const timers = new Map(); // activityId -> timeoutId

function todayKey() {
  return DAY_KEYS[new Date().getDay()];
}

function timeToTodayDate(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
}

export function isSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function permissionState() {
  if (!isSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestPermission() {
  if (!isSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function clearAllReminders() {
  for (const id of timers.values()) clearTimeout(id);
  timers.clear();
}

export function scheduleForToday(activities) {
  clearAllReminders();
  if (!isSupported() || Notification.permission !== "granted") return 0;
  const now = new Date();
  const today = todayKey();
  let count = 0;
  for (const a of activities || []) {
    if (!a.reminder || a.day !== today || a.done) continue;
    const start = timeToTodayDate(a.start_time);
    const notifyAt = new Date(start.getTime() - 5 * 60 * 1000); // 5 min before
    const delay = notifyAt.getTime() - now.getTime();
    if (delay <= 0) continue;
    const id = setTimeout(() => {
      try {
        new Notification("My Week reminder", {
          body: `${a.title} starts at ${a.start_time}`,
          tag: `activity-${a.id}`,
        });
      } catch { /* ignore */ }
      timers.delete(a.id);
    }, delay);
    timers.set(a.id, id);
    count += 1;
  }
  return count;
}
